import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CNav, CNavItem, CNavLink } from '@coreui/react'
import { DatePicker, Flex, Input, Select, Typography, Table, Switch, Button } from 'antd'
import React, { useState } from 'react'
import { useEffect, useMemo, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addAbonement, editAbonement, getAbonementTypes } from 'src/store/Slices/AbonementsSlice'
import { getAbonementsList } from 'src/store/Slices/AbonementsSlice';
import { getClubs } from 'src/store/Slices/DropDownSlice'
import { openNotification } from 'src/components/helpers/notification';
import {
    deleteAbonementClub, editAbonementClub,
    editOrderAbonementClubs,
    getAbonementListClubItems,
    getAbonementListClubServices,
    getAbonementsListClubs, getAbonementsListClubsById,
  } from 'src/store/Slices/AbonementsSlice'

import { HolderOutlined } from '@ant-design/icons';
import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { width } from '@mui/system'

const RowContext = React.createContext({});

const DragHandle = () => {
    const { setActivatorNodeRef, listeners } = useContext(RowContext);
    return (
      <Button
        type="text"
        size="small"
        icon={<HolderOutlined />}
        style={{ cursor: 'move' }}
        ref={setActivatorNodeRef}
        {...listeners}
      />
    );
  };
  
  const Row = (props) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      setActivatorNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: props['data-row-key'] });
  
    const style = {
      ...props.style,
      transform: CSS.Translate.toString(transform),
      transition,
      ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
    };
  
    const contextValue = useMemo(
      () => ({ setActivatorNodeRef, listeners }),
      [setActivatorNodeRef, listeners],
    );
  
    return (
      <RowContext.Provider value={contextValue}>
        <tr {...props} ref={setNodeRef} style={style} {...attributes} />
      </RowContext.Provider>
    );
  };

const ChangeOrderModal = ({ visible, setVisible }) => {

    // HELPERS
    const dispatch = useDispatch()

    const clubs = useSelector(state => state.DropDownSlice.clubs)
    const abonementsClubsList = useSelector(state => state.AbonementsSlice.abonementsClubsList)
    const abonementsClubsListLoading = useSelector(state => state.AbonementsSlice.abonementsClubsListLoading)
    const abonementClubs = useSelector(state => state.AbonementsSlice.abonementClubs)
    const currentClub = useSelector(state => state.AbonementsSlice.abonementCurrentClub)

    // STATE
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(5)
    const [club, setClub] = useState(1)
    const [formatedRows, setFormatedRows] = useState()
    const [keys, setKeys] = useState()
    const [isChangeOrder, setIsChangeOrder] = useState(false)
    const [totalCount, setTotalCount] = useState()

    const handleTableChange = (pagination, filters, sorter) => {
      // 
      dispatch(getAbonementsListClubs({clubId: club}))
      setPage(pagination.current)
      setPageSize(pagination.pageSize)
    }

    const onDragEnd = ({ active, over }) => {
        if (active.id !== over?.id) {
            setFormatedRows((prevState) => {
            const activeIndex = prevState.findIndex((record) => record.key === active?.id);
            const overIndex = prevState.findIndex((record) => record.key === over?.id);
            return arrayMove(prevState, activeIndex, overIndex);
            });
        }
    };

    useEffect(() => {
        setFormatedRows(abonementsClubsList?.data?.value?.rows.map(element => {
          return ({
            ...element,
            isFrost: element.isFrost ? 'Да' : 'Нет',
            hasSubscription: <Switch disabled={true}  value={element.hasSubscription} onChange={() => changeSubscribe(element)}/>,
            isPrimary:  <Switch disabled={true} value={element.isPrimary} onChange={() => changeMainAbonement(element)}/>
          })
      
        }))
      
    }, [abonementsClubsList])
    
    useEffect(() => {
    setKeys(abonementsClubsList?.data?.value?.rows.map((i) => i.key))
    setTotalCount(abonementsClubsList?.data?.value?.totalCount)
    }, [abonementsClubsList])
      
    useEffect(() => {
        setClub(1)
    }, [clubs, visible])
    
    useEffect(() => {
        dispatch(getClubs())
    }, [])

    useEffect(() => {
      dispatch(getAbonementsListClubs({clubId: club}))
    }, [club, visible])

    const onClickSave = () => {
      const list = formatedRows.map((element, index) => {
        return {
          id: element.id,
          order: index + 1
        }
      })
      dispatch(editOrderAbonementClubs({list}))
      setVisible(false)
      dispatch(getAbonementsList())
    }

    return (
        <CModal
            alignment="center"
            visible={visible}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible(false) }}
            keyboard={true}
            size="xl"
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    'Изменить порядок'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                    <>
                        <div>
                            <Typography.Title level={5}>Клуб</Typography.Title>
                            <Select
                                placeholder='Выбрать'
                                style={{width: '100%'}}
                                value={club}
                                onChange={e => setClub(e)}
                                options={clubs?.data?.value}
                            />
                        </div>
                        <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
                          <SortableContext items={keys} strategy={verticalListSortingStrategy}>
                            <Table
                              rowKey="key"
                              bordered
                              size='small'
                              tableLayout='fixed'
                              components={{ body: { row: Row } }}
                              scroll={{x: 0, y: 226}}
                              loading={abonementsClubsListLoading}
                              pagination={false}
                              columns={abonementsClubsList && [
                                {
                                  key: 'sort',
                                  align: 'center',
                                  render: () => <DragHandle />,
                                  width: 70
                                },
                                ...abonementsClubsList?.data?.value?.columns.map(element => {
                                  const newElement = {...element}
                                  newElement.sorter = false
                                  return (
                                    {
                                      ...newElement,
                                    }
                                  )
                                })
                                ]}
                              dataSource={formatedRows}
                              onChange={handleTableChange}
                            />
                          </SortableContext>
                        </DndContext>
                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible(false) }}
                    style={{ color: '#fff' }}
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton onClick={onClickSave} style={{ color: '#fff' }}>
                    Редактировать
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default ChangeOrderModal